import { useTranslations } from "next-intl";
import { useGetDiscountInfo } from "@/features/discounts/api/hooks/use-get-discount-info";
import {
  formatCouponDiscountValue,
  toMobileOnlyCoupon,
} from "@/features/discounts/helpers/mobile-only-coupon";

// The coupon behind a typed code that works only in the mobile app, so the
// coupon list can offer the app instead of a bare error toast (MPL-3137).
export const useMobileOnlyCoupon = ({
  code,
  enabled,
}: {
  code: string | null;
  enabled: boolean;
}) => {
  const t = useTranslations("discounts");
  const { data, isLoading } = useGetDiscountInfo({
    code: code ?? "",
    options: { enabled: enabled && Boolean(code) },
  });

  if (!(code && data)) {
    return { coupon: null, isLoading };
  }

  const value = formatCouponDiscountValue(data.discount);
  const coupon = toMobileOnlyCoupon(data, {
    title: t("mobileOnlyTitle", { code: data.code }),
    description: value ? t("mobileOnlyDescription", { value }) : null,
  });

  return { coupon, isLoading };
};
